
import calculate_percentile from "./_calculatedPercentile";
import { getNorm } from '../utils/normHelpers';

function createRadarChart(normsObject, programKey, ageGroup, norms_gender, inputValuesObject, inputGroupingsObject, inputSettings, stepNames, activeInputGroupingStepIndex) 
{
    const currentStepInputGroupingsIndex = inputGroupingsObject?.findIndex(function(inputGrouping){ return inputGrouping.groupName === stepNames[activeInputGroupingStepIndex]; }); 
    const currentStepInputGroup = [...inputGroupingsObject[currentStepInputGroupingsIndex].inputTags];       

    let test_names  = []; //['Pushups', 'Situps', 'Mile', 'Shuttle', 'Plank', 'Pullups'];
    let athleteData = []; //[80, 50, 30, 40, 11, 20];
    
    currentStepInputGroup.map( (currentStepInputTag) =>
    {
        let percentile = 0.0;

        const currentInputSettingsIndex = inputSettings.findIndex(function(inputSetting){ return inputSetting.tag === currentStepInputTag; } ); 
        const thisInputsSettings        = inputSettings[currentInputSettingsIndex];

        let currentInputName = currentStepInputTag;

        if ( inputValuesObject != undefined && thisInputsSettings != null)
        {            
            currentInputName = thisInputsSettings.inputStringName;
            var tag          = inputValuesObject[currentStepInputTag];        

            // if currentStepInputTag is in normsObject, then get the norms
            const norms = getNorm(currentStepInputTag, programKey, ageGroup, norms_gender, normsObject);
            if (tag && tag.value !== -99999 && tag.value !== null && !isNaN(tag.value) && norms.mean !== null)
            {
                percentile = calculate_percentile(tag.value, norms.mean, norms.sd);
                
                if (!isNaN(percentile))
                {
                    if (currentInputName.includes('[s]' || currentInputName.includes('[sec]'))) 
                    {
                        percentile = 100.0 - percentile;
                    }
                }
                else
                    percentile = 0.0;

                athleteData.push(percentile);
                test_names.push(currentInputName);
            }
            else 
            {
                athleteData.push(0.0);
                test_names.push(currentInputName);
            }
        }
    });

    // if ASLR
    let correct_test_names = [];
    //alert(test_names)
    if (test_names.includes('ASLR RT'))
    {
      // the order of test_names should be Overhead_Squat, Shoulder_Mob_LT, ASLR_RT, ASLR_LT, Shoulder_Mob_rT
      correct_test_names = ['Overhead Squat', 'Shoulder Mob RT', 'ASLR RT', 'ASLR LT', 'Shoulder Mob LT'];
    }
    else if (test_names.includes('10yd time [s]'))
    {
      correct_test_names = ['20yd time [s]', '5-0-5 RT [s]', '10yd time [s]', '5-0-5 LT [s]'];
    }
    else if (test_names.includes('IMTP Force [N]'))
    {
      correct_test_names = ['IMTP Force [N]', 'IMTP RFD [N/s]', 'Force by BW [N/lb]', 'RFD by BW [N/s/lb]'];
    }

    // if correct_test_names is empty ssort the athleteData to match the requested order
    if (correct_test_names != null && correct_test_names.length > 0)
    {
      let correct_athleteData = [];

      for (let i = 0; i < correct_test_names.length; i++)
      {
        let index = test_names.indexOf(correct_test_names[i]);
        correct_athleteData.push(athleteData[index]);
      }

      //alert(test_names + '\n' + correct_test_names + 's\n' + athleteData + '\n' + correct_athleteData)

      athleteData = correct_athleteData;
      test_names = correct_test_names;
    }

    const show_tip = test_names.includes('ASLR RT') || 
               test_names.includes('Overhead Squat') || 
               test_names.includes('Squat') || 
               test_names.includes('Mod.Thom Pso RT') || 
               test_names.includes('SL Squat Shoulder RT')
               ? false : true;

    var chartOptions = {
        series: [   
            {
              name: '20-80%',
              data: Array(athleteData.length).fill(79), // This series sets the 80-100% range
            },
            {
              name: '20-80%',
              data: Array(athleteData.length).fill(80), // This series sets the 80-100% range
            },
            {
              name: '20-80%',
              data: Array(athleteData.length).fill(81), // This series sets the 80-100% range
            },
            {
              name: '0-20%',
              data: Array(athleteData.length).fill(20), // This series sets the 0-20% range
            },
            {
              name: '',
              data: athleteData,
            }
        ],
        chart: {
          type: 'radar', 
          zoom: {
            enabled: false,
          },
          animations: {
              enabled: false,
              animateGradually: {
                  enabled: false,
              },
              dynamicAnimation: {
                  enabled: false
              }
          },
        },
        xaxis: {
            categories: test_names,
            labels: {
                formatter: function(val) {
                    // remove units in square brackets at the end
                    try
                    {
                        val = val.replace(/\[.*?\]/g, '');
                    }
                    catch
                    {
                        //alert(val)
                    }
                    return val
                },
                textAlign: 'center',
                //offsetY: -20,
                //offsetX: 25, 
                show: true,
                style: {
                colors: Array(athleteData.length).fill('#FFFFFF'),
                fontSize: '11px',
                fontWeight: 400,
                },
            },
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 10, // This will divide your y-axis into 5 equal parts (0%, 20%, 40%, 60%, 80%, 100%)
          labels: {
            formatter: function() {
              return ''; // Append a '%' sign to the y-axis labels
            }
          }
        },
        stroke: {
            width: 2,
            colors: ['#add8ad', '#add8ad', '#add8ad', '#FFCCCC', '#FDBA31'],
        },
        fill: {
          opacity: [0.0, 0.0, 0.0, 1.0, 0.25],
          colors: ['#add8ad', '#add8ad', '#add8ad', '#FFCCCC', '#FDBA31'],
        },
        markers: {
            size: [0, 0, 0, 0, 5],
            colors: ['#add8ad', '#add8ad', '#add8ad', '#FFCCCC', '#000000'],
            strokeColor: '#FDBA31',
            strokeWidth: [0, 0, 0, 0, 5],
            hover: {
                colors: '#000000',
                strokeColor: '#000000',
                strokeWidth: 0,
                size: 10,
            }
        },
        tooltip:
          {
              theme: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
              y: {
              formatter: function(val) {
                return show_tip ? "Test percentile : " + val.toFixed(1) + '%' : 'Percentile not relevant'; // Append a '%' sign to the y-axis labels
              }
            }
        },
        legend: {
          show: false // This will hide the legend
        },
        plotOptions: {
          radar: {
            polygons: {
              strokeWidth: 2,
              strokeColor: '#000000',
              fill: {
                  colors: ['#f8f8f8', '#fff']
              }
            }
          }
        }
    };

    return chartOptions;
}

export default createRadarChart;
